import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiHeart, FiMessageCircle, FiUserPlus, FiBell } from 'react-icons/fi';
import { usersAPI } from '../utils/api';
import { format } from 'timeago.js';

const ICONS = {
  like:       <FiHeart style={{ color: '#EF4444' }} />,
  comment:    <FiMessageCircle style={{ color: '#3B82F6' }} />,
  follow:     <FiUserPlus style={{ color: '#10B981' }} />,
  mention:    <FiMessageCircle style={{ color: '#8B5CF6' }} />,
  story_view: <FiBell style={{ color: '#F59E0B' }} />,
};
const MESSAGES = {
  like: 'liked your post', comment: 'commented on your post',
  follow: 'started following you', mention: 'mentioned you', story_view: 'viewed your story',
};

export default function Notifications() {
  const [notifs, setNotifs]   = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    usersAPI.getNotifications()
      .then(r => setNotifs(r.data.notifications || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="page-container" style={{ maxWidth: 580 }}>
      <h2 style={{ marginBottom: 'var(--sp-4)' }}>Notifications</h2>

      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: 'var(--sp-6)' }}><span className="spinner" /></div>
      ) : notifs.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 'var(--sp-6) var(--sp-4)', color: 'var(--text-3)' }}>
          <FiBell size="clamp(36px,10vw,52px)" style={{ margin: '0 auto var(--sp-3)', display: 'block' }} />
          <p className="font-bold" style={{ fontSize: 'var(--fs-lg)', marginBottom: 'var(--sp-2)' }}>No notifications yet</p>
          <p style={{ fontSize: 'var(--fs-sm)' }}>Likes and comments on your posts appear here.</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'clamp(3px,0.5vw,6px)' }}>
          {notifs.map(n => (
            <div key={n.id} className={"notif-item card" + (n.is_read ? '' : ' unread')}>
              <Link to={`/profile/${n.actor_id}`} style={{ textDecoration: 'none', flexShrink: 0 }}>
                {n.avatar
                  ? <img src={n.avatar} className="avatar" style={{ width: 'clamp(36px,7vw,46px)', height: 'clamp(36px,7vw,46px)' }} alt="" />
                  : <div style={{ width: 'clamp(36px,7vw,46px)', height: 'clamp(36px,7vw,46px)', borderRadius: '50%', background: 'linear-gradient(135deg,#E91E8C,#7B2FF7)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 700, fontSize: 'clamp(14px,3vw,18px)', flexShrink: 0 }}>
                      {n.full_name?.[0] || n.username?.[0]}
                    </div>
                }
              </Link>
              <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ fontSize: 'var(--fs-sm)', lineHeight: 1.5 }}>
                  <Link to={`/profile/${n.actor_id}`} className="font-bold">{n.username}</Link>
                  {' '}{MESSAGES[n.type] || n.type}
                  <span style={{ color: 'var(--text-3)', marginLeft: 6, fontSize: 'var(--fs-xs)' }}>{format(n.created_at)}</span>
                </p>
              </div>
              <div style={{ width: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                {ICONS[n.type]}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
